import { Layout, Table, TableRow, TableRowDisplayEvent, Tabset } from "@mcleod/components";
import { AutogenLayoutBillingUsers } from "./autogen/AutogenLayoutBillingUsers";

export class BillingUsers extends AutogenLayoutBillingUsers {
    private _isCreditBill: boolean = false;
    onLoad(): void | Promise<void> {
        if (this.isCreditBill) {
            this.disableCreditFields(this);
        }
        const LME_USER_FILTER = event => { event.filter.web_user_type = "U" };
        this.textboxBillingUserId.addBeforeLookupModelSearchListener(LME_USER_FILTER);
        this.textboxOperationsUser.addBeforeLookupModelSearchListener(LME_USER_FILTER);
        this.textboxEnteredUserId.addBeforeLookupModelSearchListener(LME_USER_FILTER);
    }

    disableCreditFields(component?: Layout | TableRow | Tabset) {
        const rootComponent = component ?? this;
        rootComponent.forEveryChildComponent(comp => {
            comp.enabled = false;

            if (comp instanceof Table) {
                const nestedTable: Table = comp as Table
                nestedTable.addRowDisplayListener((event: TableRowDisplayEvent) => {
                    const row: TableRow = (event as TableRowDisplayEvent).getTableRow();
                    row.forEveryChildComponent(child => {
                        child.enabledDuringUpdate = false;
                    });
                });
            }
        });
    }
    
    public get isCreditBill(): boolean {
        return this._isCreditBill;
    }

    public set isCreditBill(value: boolean) {
        this._isCreditBill = value;
    }
    
}